import React from 'react';
import { Line } from 'react-konva';
import { SnapLine } from '../hooks/useSnapping';

/**
 * Props for SnapLines component
 */
interface SnapLinesProps {
  /** Array of snap lines to render */
  snapLines: SnapLine[];
}

/**
 * Component for rendering snap guide lines
 */
export const SnapLines: React.FC<SnapLinesProps> = ({ snapLines }) => {
  
  return (
    <>
      {snapLines.map((line, i) => {
        return (
          <Line
            key={`snap-line-${i}`}
            points={line.points}
            stroke="#F24E1E" // Figma-like orange
            strokeWidth={1}
            listening={false}
          />
        );
      })}
    </>
  );
};